// π ----
// :: MODULES BOOTSTRAP ---------------------------::
// ____

/* :: Imports
---------------------------------- */
import Vue from 'vue';
import { extend, ValidationProvider, ValidationObserver } from 'vee-validate/dist/vee-validate.full.esm'
import MobileNavigation from './components/MobileNavigation';
import MenuDropdown from './components/MenuDropdown';
import ApplicationForm from './components/Forms/ApplicationForm'
import ApplyNowForm from './components/Forms/ApplyNow/ApplyNowForm'
import ContactUsForm from './components/Forms/ContactUsForm/ContactUsForm'
import LazyLoad from 'vanilla-lazyload';
import { initCookies } from './functions/cookies.js'
import dayjs from 'dayjs'
dayjs().format()

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)

extend('included', {
    validate: (selected, options) => options.includes(selected)
})
extend('date', {
    validate: () => true
})

export default {
    init() {
        initCookies()
        const app = new Vue({
            el: '#root',
            components: { MobileNavigation, MenuDropdown, ApplicationForm, ApplyNowForm, ContactUsForm }
        });
    },
    finalize() {
        const elementsToLazyLoad = document.querySelectorAll('.lazy');
        new LazyLoad(
            {
                use_native: false,
            },
            elementsToLazyLoad
        );
    }
};
